import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { InsignStartComponent } from '@app/modules/insign-confirm/pages/insign-start/insign-start.component';
import { InsignFinishComponent } from '@app/modules/insign-confirm/pages/insign-finish/insign-finish.component';


@NgModule({
    declarations: [
        InsignStartComponent,
        InsignFinishComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
    ]
})
export class InsignModule { }
